export type PrintGatewayStatus = {
  server_printing: boolean;
  mode: "gateway" | "direct" | "relay_only";
  connector_reachable?: boolean | null;
  status?: {
    handshake_age_s?: number;
    interface_up?: boolean;
    /** Unix milliseconds, matching other API timestamps. */
    updated_at?: number;
  } | null;
};

export type GatewayState = "relay" | "configured" | "online" | "offline" | "unavailable";

export function isPrintGatewayStatus(value: unknown): value is PrintGatewayStatus {
  if (!value || typeof value !== "object") return false;
  const body = value as Record<string, unknown>;
  return typeof body.server_printing === "boolean" &&
    typeof body.mode === "string" && ["gateway", "direct", "relay_only"].includes(body.mode);
}

/** A reachable connector alone does not prove the shop's tunnel is connected. */
export function gatewayState(info: PrintGatewayStatus, now = Date.now()): GatewayState {
  if (!info.server_printing || info.mode === "relay_only") return "relay";
  if (info.mode === "gateway" && info.connector_reachable === false) return "unavailable";
  const status = info.status;
  if (!status || typeof status !== "object") return "configured";
  const updated = status.updated_at;
  if (typeof updated !== "number" || !Number.isFinite(updated) ||
      updated < now - 120_000 || updated > now + 30_000) return "configured";
  if (status.interface_up === false) return "offline";
  const age = status.handshake_age_s;
  if (status.interface_up !== true || typeof age !== "number" || !Number.isFinite(age) || age < 0) return "configured";
  const effectiveAge = age + Math.max(0, now - updated) / 1000;
  if (effectiveAge > 180) return "offline";
  return info.mode === "direct" || info.connector_reachable === true ? "online" : "configured";
}
